module.exports = "/packs/images/svg/hamburger~eeece2ea60aaf7c66457f1cdb2a66e6d.svg";